export class Avatars {

  // As stored in S3: https://s3.console.aws.amazon.com/s3/buckets/cwkimages/web/account/avatars/
  STUDENT_AVATARS = [
    'boy-1-kid.png',
    'boy-2-kid.png',
    'boy-3-kid.png',
    'boy-4-kid.png',
    'boy-5-kid.png',
    'boy-6-kid.png',
    'boy-7-kid.png',
    'boy-8-kid.png',
    'boy-9-kid.png',
    'boy-10-teen.png',
    'boy-11-teen.png',
    'boy-12-teen.png',
    'boy-13-teen.png',
    'boy-14-teen.png',
    'boy-15-teen.png',
    'boy-16-teen.png',
    'boy-17-teen.png',
    'boy-18-teen.png',
    'girl-1-kid.png',
    'girl-2-kid.png',
    'girl-3-kid.png',
    'girl-4-kid.png',
    'girl-5-kid.png',
    'girl-6-kid.png',
    'girl-7-kid.png',
    'girl-8-kid.png',
    'girl-9-kid.png',
    'girl-10-teen.png',
    'girl-11-teen.png',
    'girl-12-teen.png',
    'girl-13-teen.png',
    'girl-14-teen.png',
    'girl-15-teen.png',
    'girl-16-teen.png',
    'girl-17-teen.png',
    'girl-18-teen.png',
    'girl-19-teen.png',
    'girl-20-teen.png',
    'girl-21-teen.png'
  ];
}
